import styled from 'styled-components';

export const Container = styled.div`
    background-color: #000000;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    color: #fff;
    position: absolute;
    top: 0;
    z-index: 3;

    h2 {
        margin: 10px;
        text-transform: uppercase;
    }

    h3 {
        text-align: center;
    }
    
`;
